import { createContext, useReducer } from 'react';
import MovementEntity from '../../models/MovementEntity';

export const ReceptionContext = createContext();

const ReceptionProvider = ({ children, movement = MovementEntity }) => {
    const reducer = (state, action) => {
        switch (action.type) {
            case 'EDIT':
                return {
                    ...state,
                    movement: {
                        ...state.movement,
                        ...action.payload
                    }
                }
            case 'SET_LOADING': {
                return {
                    ...state,
                    loading: action.payload
                }
            }
            default:
                return state
        }
    }

    return (
        <ReceptionContext.Provider value={useReducer(reducer, { movement, loading: false })}>
            {children}
        </ReceptionContext.Provider>
    )
}

export default ReceptionProvider;